// 전자서명 페이지 JavaScript

// 페이지 로드 시 실행
document.addEventListener('DOMContentLoaded', function() {
  // so_c4020 페이지에서는 매번 새로 인증해야 함
  const currentPage = window.location.pathname;
  if (currentPage.includes('so_c4020')) {
    sessionStorage.removeItem('certCompleted');
  }
  
  loadApplicationData();
  checkCertStatus();
});

// 신청 데이터 로드 (더미 데이터 - 실제로는 세션이나 서버에서 가져옴)
function loadApplicationData() {
  // so_c2032에서 입력한 데이터를 가져옴 (실제로는 세션 스토리지나 서버에서)
  const dummyData = {
    customerName: '홍길동',
    ssn: '901234-*******',
    stockAccount: '1234-5678-90',
    interestRate: '연 7.5%',
    limitAmount: '10,000',
    loanAmount: '5,000',
    additionalCost: '5',
    actualAmount: '4,995',
    applicationDate: getCurrentDate(),
    interestPaymentDate: '매월 1일',
    executionDate: '관리자실행일',
    maturityDate: '대출실행일로 부터 6개월',
    pledgeAgreementDate: getCurrentDate(),
    pledgeAmount: '130%'
  };

  // 데이터 표시
  for (const [key, value] of Object.entries(dummyData)) {
    const element = document.getElementById(key);
    if (element) {
      element.value = value;
    }
  }
  
  // 실입금액에만 한글 표시
  updateAmountKorean('actualAmount', 'actualAmountKorean');
}

// 금액 필드의 한글 표시 업데이트
function updateAmountKorean(amountId, koreanId) {
  const amountElement = document.getElementById(amountId);
  const koreanElement = document.getElementById(koreanId);
  
  if (amountElement && koreanElement) {
    const amount = parseInt(amountElement.value.replace(/[^0-9]/g, '')) || 0;
    if (amount > 0) {
      // loan_form.js의 numberToKorean 함수 사용
      koreanElement.textContent = numberToKorean(amount);
    }
  }
}

// 현재 날짜 가져오기
function getCurrentDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// 공동인증서 상태 확인
function checkCertStatus() {
  const certStatus = sessionStorage.getItem('certCompleted');
  if (certStatus === 'true') {
    completeCertification();
  }
}

// 공동인증서 모달 열기
function openCertModal() {
  const certButton = document.getElementById('certButton');
  if (certButton.classList.contains('completed')) {
    return;
  }
  
  const modal = document.getElementById('certModal');
  modal.classList.add('active');
  
  // 모달 외부 클릭 시 닫기
  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      closeCertModal();
    }
  });
  
  // ESC 키로 닫기
  document.addEventListener('keydown', handleEscKey);
}

// 공동인증서 모달 닫기
function closeCertModal() {
  const modal = document.getElementById('certModal');
  modal.classList.remove('active');
  document.removeEventListener('keydown', handleEscKey);
  
  // 입력 필드 초기화
  const passwordInput = document.getElementById('certPassword');
  if (passwordInput) {
    passwordInput.value = '';
  }
}

// ESC 키 핸들러
function handleEscKey(e) {
  if (e.key === 'Escape') {
    closeCertModal();
  }
}

// 공동인증서 확인 (더미 인증)
function confirmCert() {
  const passwordInput = document.getElementById('certPassword');
  const password = passwordInput ? passwordInput.value : '';
  
  if (!password) {
    alert('인증서 비밀번호를 입력해주세요.');
    return;
  }
  
  // 더미 인증 처리 (실제로는 API 호출)
  setTimeout(function() {
    // 인증 완료 처리
    sessionStorage.setItem('certCompleted', 'true');
    completeCertification();
    closeCertModal();
    
    // 현재 페이지 확인하여 다른 메시지 표시
    const currentPage = window.location.pathname;
    if (currentPage.includes('so_c4020')) {
      // 대출상환/해지 페이지 - action에 따라 구분
      const repaymentAction = sessionStorage.getItem('repaymentAction');
      if (repaymentAction === 'terminate') {
        showTerminateCompletionMessage();
      } else {
        showRepaymentCompletionMessage();
      }
    } else {
      // 대출신청 페이지 (so_c2034)
      showCompletionMessage();
    }
  }, 500);
}

// 인증 완료 처리
function completeCertification() {
  const certButton = document.getElementById('certButton');
  const certStatus = document.getElementById('certStatus');
  
  certButton.classList.add('completed');
  certButton.textContent = '공동인증서 (완료)';
  certButton.style.cursor = 'not-allowed';
  certButton.style.background = '#6c757d';
  certButton.style.color = '#ffffff';
  certButton.disabled = true;
  
  if (certStatus) {
    certStatus.textContent = '✓ 전자서명이 완료되었습니다.';
    certStatus.style.display = 'block';
  }
}

// 대출신청완료 메시지 표시 및 약정서 페이지로 이동
function showCompletionMessage() {
  // 전자서명 섹션으로 스크롤 (백그라운드가 보이도록)
  const signatureSection = document.querySelector('.loan-form-section:last-of-type');
  if (signatureSection) {
    // 섹션이 화면 하단에 오도록 계산 (상대값)
    const targetPosition = signatureSection.offsetTop - window.innerHeight + 200;
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
  
  // 완료 메시지 모달 생성
  const completionModal = document.createElement('div');
  completionModal.className = 'cert-modal active';
  completionModal.innerHTML = `
    <div class="cert-modal-content">
      <div class="cert-modal-body">
        <div class="cert-dummy-content">
          <div class="cert-icon">✅</div>
          <p class="cert-title">대출실행완료</p>
          <p class="cert-description">대출 실행이 정상적으로 완료되었습니다.<br>약정서 페이지로 이동합니다.</p>
        </div>
      </div>
      <div class="cert-modal-footer">
        <button type="button" class="cert-modal-btn cert-modal-btn-confirm" onclick="goToContract()">확인</button>
      </div>
    </div>
  `;
  
  document.body.appendChild(completionModal);
}

// 약정서 페이지로 이동
function goToContract() {
  // 모달 제거
  const completionModal = document.querySelector('.cert-modal.active');
  if (completionModal) {
    completionModal.remove();
  }
}

// 상환신청완료 메시지 표시 및 대출거래현황 페이지로 이동 (so_c4020 전용)
function showRepaymentCompletionMessage() {
  // 전자서명 섹션으로 스크롤
  const signatureSection = document.querySelector('.loan-form-section:last-of-type');
  if (signatureSection) {
    const targetPosition = signatureSection.offsetTop - window.innerHeight + 200;
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
  
  // 완료 메시지 모달 생성
  const completionModal = document.createElement('div');
  completionModal.className = 'cert-modal active';
  completionModal.innerHTML = `
    <div class="cert-modal-content">
      <div class="cert-modal-body">
        <div class="cert-dummy-content">
          <div class="cert-icon">✅</div>
          <p class="cert-title">상환신청완료</p>
          <p class="cert-description">상환 신청이 정상적으로 완료되었습니다.<br>대출거래현황으로 이동합니다.</p>
        </div>
      </div>
      <div class="cert-modal-footer">
        <button type="button" class="cert-modal-btn cert-modal-btn-confirm" onclick="goToTransactionStatus()">확인</button>
      </div>
    </div>
  `;
  
  document.body.appendChild(completionModal);
}

// 대출거래현황 페이지로 이동 (so_c4020에서 사용)
function goToTransactionStatus() {
  // action 값 초기화
  sessionStorage.removeItem('repaymentAction');
  // Vue Router로 이동
  if (window.vueRouter) {
    window.vueRouter.push({ name: 'LoanInfo' });
  }
}

// 대출신청 완료 후 대출거래정보로 이동 (so_c2032에서 사용)
function showApplicationCompletionModal() {
  // 완료 메시지 모달 생성
  const completionModal = document.createElement('div');
  completionModal.className = 'cert-modal active';
  completionModal.innerHTML = `
    <div class="cert-modal-content">
      <div class="cert-modal-body">
        <div class="cert-dummy-content">
          <div class="cert-icon">✅</div>
          <p class="cert-title">대출신청완료</p>
          <p class="cert-description">대출 신청이 정상적으로 완료되었습니다.<br>마이페이지의 대출거래정보 화면으로 이동합니다.</p>
        </div>
      </div>
      <div class="cert-modal-footer">
        <button type="button" class="cert-modal-btn cert-modal-btn-confirm" onclick="goToLoanTransaction()">확인</button>
      </div>
    </div>
  `;
  
  document.body.appendChild(completionModal);
}

// 대출거래정보 화면으로 이동 (Vue Router 사용)
function goToLoanTransaction() {
  // 모달 제거
  const completionModal = document.querySelector('.cert-modal.active');
  if (completionModal) {
    completionModal.remove();
  }
  // Vue Router로 이동
  if (window.vueRouter) {
    window.vueRouter.push({ name: 'LoanInfo' });
  }
}

// 대출실행 완료 후 약정서 페이지로 이동 (so_c2034에서 사용)
function showExecutionCompletionModal() {
  // 완료 메시지 모달 생성
  const completionModal = document.createElement('div');
  completionModal.className = 'cert-modal active';
  completionModal.innerHTML = `
    <div class="cert-modal-content">
      <div class="cert-modal-body">
        <div class="cert-dummy-content">
          <div class="cert-icon">✅</div>
          <p class="cert-title">대출실행완료</p>
          <p class="cert-description">대출 실행이 정상적으로 완료되었습니다.<br>약정서 페이지로 이동합니다.</p>
        </div>
      </div>
      <div class="cert-modal-footer">
        <button type="button" class="cert-modal-btn cert-modal-btn-confirm" onclick="goToContract()">확인</button>
      </div>
    </div>
  `;
  
  document.body.appendChild(completionModal);
}

// 해지신청완료 메시지 표시 및 대출거래현황 페이지로 이동 (so_c4020 해지 전용)
function showTerminateCompletionMessage() {
  // 전자서명 섹션으로 스크롤
  const signatureSection = document.querySelector('.loan-form-section:last-of-type');
  if (signatureSection) {
    const targetPosition = signatureSection.offsetTop - window.innerHeight + 200;
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
  
  // 완료 메시지 모달 생성
  const completionModal = document.createElement('div');
  completionModal.className = 'cert-modal active';
  completionModal.innerHTML = `
    <div class="cert-modal-content">
      <div class="cert-modal-body">
        <div class="cert-dummy-content">
          <div class="cert-icon">✅</div>
          <p class="cert-title">해지신청완료</p>
          <p class="cert-description">해지신청이 완료되었습니다.<br>대출거래현황으로 이동합니다.</p>
        </div>
      </div>
      <div class="cert-modal-footer">
        <button type="button" class="cert-modal-btn cert-modal-btn-confirm" onclick="goToTransactionStatus()">확인</button>
      </div>
    </div>
  `;
  
  document.body.appendChild(completionModal);
}

// 페이지 이탈 전 경고 (인증 완료 전) - 서명 페이지에서만 작동
window.addEventListener('beforeunload', function(e) {
  // 서명 페이지에서만 경고 표시 (현재 경로 확인)
  const isSignaturePage = window.location.pathname.includes('so_c2034') || 
                          window.location.pathname.includes('signature');
  
  if (!isSignaturePage) {
    return; // 서명 페이지가 아니면 경고 안 함
  }
  
  const certStatus = sessionStorage.getItem('certCompleted');
  if (certStatus !== 'true') {
    e.preventDefault();
    e.returnValue = '';
    return '';
  }
});

// 전역 함수 노출 (Vue에서 사용 가능)
window.loadApplicationData = loadApplicationData;
window.updateAmountKorean = updateAmountKorean;
window.getCurrentDate = getCurrentDate;
window.checkCertStatus = checkCertStatus;
window.openCertModal = openCertModal;
window.closeCertModal = closeCertModal;
window.confirmCert = confirmCert;
window.completeCertification = completeCertification;
window.showCompletionMessage = showCompletionMessage;
window.goToContract = goToContract;
window.showRepaymentCompletionMessage = showRepaymentCompletionMessage;
window.goToTransactionStatus = goToTransactionStatus;
window.showTerminateCompletionMessage = showTerminateCompletionMessage;
window.showApplicationCompletionModal = showApplicationCompletionModal;
window.goToLoanTransaction = goToLoanTransaction;
window.showExecutionCompletionModal = showExecutionCompletionModal;
// ES ���� export
export {
  loadApplicationData,
  updateAmountKorean,
  getCurrentDate,
  checkCertStatus,
  openCertModal,
  closeCertModal,
  confirmCert,
  completeCertification,
  showCompletionMessage,
  goToContract,
  showRepaymentCompletionMessage,
  goToTransactionStatus,
  showTerminateCompletionMessage,
  showApplicationCompletionModal,
  goToLoanTransaction
};

export default {
  loadApplicationData,
  updateAmountKorean,
  getCurrentDate,
  checkCertStatus,
  openCertModal,
  closeCertModal,
  confirmCert,
  completeCertification,
  showCompletionMessage,
  goToContract,
  showRepaymentCompletionMessage,
  goToTransactionStatus,
  showTerminateCompletionMessage,
  showApplicationCompletionModal,
  goToLoanTransaction
};
